import 'passwordStrength';
import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import UserModel from 'js/models/profileinfo.model';
import Template from 'js/templates/profile.user.hbs';
import AppUserActionView from 'js/views/profile.appuseraction.view';
import countriescode from 'countriescode';
import moment from 'moment-timezone';
import dhtmlx from 'dhtmlxAdapter';
import sha1 from 'sha1';

import {_} from "backboneAdapter";
import {el, handles, on, tagName, template} from "../adapters/backbone-decorators";
import 'zxcvbn';
import QRCode from "qrcode";

var appUserActionView = null;
var appUserActionIsVisible = false;

// Returning instantiated views can be quite useful for having "state"
@el("#profile-container")
@tagName('span')
@template(Template)
class ProfileUserView extends GenericView {

    delegateEvents(events) {
        this.cid = 'add-dialog';
        super.delegateEvents(events);
    }

    constructor(options) {
        super(options);
        const {isPostPaid} = options;
        if (isPostPaid) {
            $("#plan-type").hide();
            $("#upgrade-link").hide();
            $("#expiration-date").hide();
        }
        $('.cancelButton').click(event => {
            this.promptClosedByUser(event);
        });
        $('.icon-cancel-2').attr('title', i18n.t("dashboard.neverShowAgain"));
        this.showPrompts();
        this.is2FAEnabledFunc().then(() => {
            this.model = new UserModel();
            this.model.bind("add remove", this.loadUser, this);
            this.loadUser();
        });
    }

    hide() {
        this.$el.hide();
    }

    show() {
        $("#invoice-container").show();
        this.$el.show();
    }

    async render() {
        var self = this;
        var curCountry = this.model.get("countryCode");
        var countryName = countriescode.alphaToCountry(curCountry);
        this.model.set("countryName", countryName);
        super.render();
        await self.is2FAEnabledFunc();
        try {
            const pendingEmailChange = await $.ajaxDefaultQ({
                url: '/CampaignCloud/EmailChangeRequest/PendingEmailChangeRequestConfirmation',
                type: 'POST',
                dataType: "json"
            });
            if (pendingEmailChange.status === 'success') {
                if (pendingEmailChange.state === 'thereIsPendingRequest') {
                    $('#change-email-button').hide();
                    $('#email-for-confirmation').text(pendingEmailChange.pendingConfirmationEmail);
                    $('#pending-change-email-confirmation').show();
                    $('#emailInput').editable('disable');
                } else {
                    $('#change-email-button').show();
                    $('#email-for-confirmation').text('');
                    $('#pending-change-email-confirmation').hide();
                }
            } else {
                console.info(`There is not pending request for email change!${pendingEmailChange}`);
            }
        } catch (e) {
            console.info(`error!${e}`);
        }
        this.$('[data-i18n]').i18n();

        const passwordLevelLabel = i18n.t("profile.passwordlevel") +": ";

        $('#passInput').pwstrength({
            i18n: i18n,
            ui: {
                verdicts: [
                    i18n.t("veryWeak", {label: passwordLevelLabel}),
                    i18n.t("weak", {label: passwordLevelLabel}),
                    i18n.t("normal", {label: passwordLevelLabel}),
                    i18n.t("medium", {label: passwordLevelLabel}),
                    i18n.t("strong", {label: passwordLevelLabel}),
                    i18n.t("veryStrong", {label: passwordLevelLabel})
                ],
                colorClasses: ["danger", "danger", "danger", "warning", "success", "success"]
            },
            common: {
                zxcvbn: true,
                onKeyUp(evt, data) {
                    var strongPass = data.verdictLevel > 3;
                    _.bind(self.checkPassword, self)(strongPass);
                }
            }
        });
    }

    getTimezones() {
        return moment.tz.names();
    }

    getCountries() {
        return countriescode.getCountries();
    }

    handleUpdate(value, settings, e) {
        if ($(e).hasClass('timezone')) {
            var tzs = this.getTimezones();
            value = tzs[value];
        } else if ($(e).hasClass('email')) {
            this.submitNewEmail(value);
            $(e).text(this.model.get('email'));
            return;
        }
        super.handleUpdate(value, settings, e);
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if ($(e).hasClass("select")) {
            $(e).text(countriescode.alphaToCountry(value));
            $(e).prev("i")
                .removeClass()
                .addClass("flag-icon")
                .addClass(`flag-icon-${value.toLowerCase()}`);
        }
        if ("OK" === outcome) {
            if (attributeName === "firstName" || attributeName === "lastName" || attributeName === "crmSubscriberId") {
                $("#username-for-display").text(this.model.get("displayName"));
                this.trigger("changed:user");
            }
        }

        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    @on('click #totpToggle')
    async totpToggle() {
        var self = this;
        try {
            if (self.is2FAEnabled) {
                const {outcome} = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/disable2FA',
                    type: 'post',
                    dataType: "json"
                });
                if (outcome === "OK") {
                    $.Notify.show(i18n.t("totp.disabledSuccessfully"));
                } else {
                    throw new Error(outcome);
                }
                await self.is2FAEnabledFunc();
            } else {
                const {outcome} = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/enable2FA',
                    type: 'post',
                    dataType: "json"
                });
                if (outcome === "OK") {
                    $.Notify.show(i18n.t("totp.enabledSuccessfully"));
                } else {
                    throw new Error(outcome);
                }
                await self.is2FAEnabledFunc();
                await self.toggleQRModal(self);
            }
        } catch (e) {
            $.Notify.show(i18n.t("totp.enabledUnsuccessfully"));
        }
    }

    async toggleQRModal(self) {
        try {
            const {outcome, data} = await $.ajaxDefaultQ({
                url: '/CampaignCloud/qrcode',
                type: 'get',
                dataType: "json"
            });
            if (outcome !== "Failure") {
                const src = await QRCode.toDataURL(data, {scale: 7});
                await dhtmlx.alert(i18n.t("totp.qrcodetext", {src}));
                self.openVerificationModal(self);
            } else {
                $.Notify.show(i18n.t("totp.qrcodefailure"));
            }
        } catch (e) {
            $.Notify.show(i18n.t("totp.qrcodefailure"));
        }
    }

    async openVerificationModal(self) {
        const modalbox = await dhtmlx.modalbox({
            text: i18n.t("totp.verifyCode"),
            buttons: [i18n.t("satisfaction.okayLabel"), i18n.t("backbtn"), i18n.t("cancelbtn")],
        });
        const result = await modalbox;
        if (result === "0") {
            var code = $(modalbox.getElementsByTagName('input')[0]).val();
            try {
                const {outcome} = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/verifyTotp',
                    type: 'post',
                    data: {code: code},
                    dataType: "json"
                });
                const outcomeMsg = {
                    "Verification Successful": "totp.verificationSuccessful",
                    "Verification Failure": "totp.verificationFailure",
                    "Empty Code": "totp.emptyCode",
                    "Not a number": "totp.notANumber",
                    "2FA not enabled": "totp.2FANotEnabled",
                };
                await dhtmlx.alert(i18n.t(outcomeMsg[outcome]));
                if (outcome === "Verification Successful")
                    self.openVerificationModal(self);
            } catch (e) {
                $.Notify.show(i18n.t("totp.verificationFailure"));
            }
        } else if (result === "1") {
            self.toggleQRModal(self);
        } else if (result === "2") {
            self.totpToggle();
        }
    }

    async is2FAEnabledFunc() {
        var self = this;
        try {
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/is2FAEnabled',
                type: 'get',
                dataType: "json"
            });
            if (response['2FAEnabled']) {
                $('#totpToggle').text(i18n.t("totp.disable"));
            } else {
                $('#totpToggle').text(i18n.t("totp.enable"));
            }
            self.is2FAEnabled = response['2FAEnabled'];
        } catch (e) {
            $.Notify.error(i18n.t("totp.failureToReadState"));
        }
    }

    emailOnEdit(var1, var2) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@(((hotmail)?(yahoo)?(outlook)?\.([a-z]{2,6}(?:\.[a-z]{2})?))?)((gmail.com)?)$/i;
        if (re.test(var2.textContent)) {
            dhtmlx.alert(i18n.t("profile.emailChangeAlert"));
        }
    }

    @handles('app.loadUser')
    async loadUser() {
        var self = this;

        console.info("Fetching user");
        await this.model.fetch();
        self.getTimezone();
        self.getCountryCode();
        self.model.urlRoot = '/CampaignCloud/Subscriber';
        self.render();
    }

    @on('click #invoice-checkbox [type="checkbox"]')
    receiveInvoice() {
        if ($('#invoice').prop('checked')) {
            $('#invoice-info').show();
        } else {
            $('#invoice-info').hide();
        }
    }

    async getTimezone() {
        try {
            if (!this.model.get("timezone")) {
                var url = '/CampaignCloud/Geolocation/timezone';
                const data = await $.ajaxDefaultQ({
                    url: url,
                    type: "GET",
                    dataType: "json"
                });
                if (data.status === 'success') {
                    $('#timezone').text(data.response);
                } else {
                    throw new Error(data);
                }
            }
        } catch (e) {
            console.log("failed");
        }
    }

    async getCountryCode() {
        try {
            if (!this.model.get("countryCode")) {
                var url = '/CampaignCloud/Geolocation/countryCode';
                const data = await $.ajaxDefaultQ({
                    url: url,
                    type: "GET",
                    dataType: "json"
                });
                if (data.status === 'success') {
                    var $countryCode = $('#countryCode');
                    var sprite = $countryCode.prev('i');
                    sprite.addClass('flag-icon');
                    sprite.addClass('flag-icon-' + data.countryCode.toLowerCase());
                    $countryCode.text(data.country);
                } else {
                    throw new Error(data);
                }
            }
        } catch (e) {
            console.log("failed");
        }
    }

    @on('click #newpass-button')
    newPassword() {
        // clear the inputs and trigger `keyup` so the appropriate icons can be displayed
        $("#oldPassInput").val('')
            .attr("type", "password").trigger("keyup");
        $("#passInput").val('')
            .attr("type", "password").trigger("keyup");
        $("#verifyPassInput").val('')
            .attr("type", "password").trigger("keyup");

        $('#newpass-form').show();
    }

    @on("mousedown .togglePasswordField")
    showPasswordField(e) {
        this.setInputType(e, "text");
    }

    @on("mouseup .togglePasswordField")
    hidePasswordField(e) {
        this.setInputType(e, "password");
    }

    setInputType(e, type) {
        const $elem = $(e.target);
        const $passInput = $elem.parent().find(".password input");

        $passInput.attr('type', type);
    }

    @on('click #cancel-btn')
    cancelNewPassword() {
        // clear the inputs and trigger `keyup` so the appropriate icons can be displayed
        var $oldPassInput = $('#oldPassInput');
        $oldPassInput.val('')
            .attr("type", "password").trigger("keyup");

        var $passInput = $('#passInput');
        $passInput.val('')
            .attr("type", "password").trigger("keyup");

        var $verifyPassInput = $('#verifyPassInput');
        $verifyPassInput.val('')
            .attr("type", "password").trigger("keyup");

        $('#psw-error-message').addClass('confirm-failure').empty();
        $oldPassInput.removeClass('confirm-failure-input-borders');
        $passInput.removeClass('confirm-failure-input-borders');

        $('#oldpsw-error-message').addClass('confirm-failure').empty();
        $('#newEmailInput').removeClass('confirm-failure-input-borders');
        $('#newpass-form').hide();
    }

    checkPassword(strongPass) {
        var $passInput = $('#passInput');
        var password = $passInput.val();
        var strengthText = $('.password-verdict').text();

        if (!password.length) {
            $passInput.removeClass('valid-input');
            $passInput.addClass('required-input');
        } else if (!strongPass) {
            $passInput.removeClass('invalid-input');
            $passInput.removeClass('valid-input');
            $passInput.removeClass('confirm-failure-input-borders');
            $passInput.addClass('required-input');
            $('#submit-btn').attr('disabled', true);
        } else {
            $passInput.removeClass('required-input');
            $passInput.addClass('valid-input');
            $("#submit-btn").removeAttr("disabled");
        }
    }

    @on('keyup input#passInput')
    checkNewPassword(e) {
        this.checkVerifyPassword(e);
    }

    @on('keyup input#verifyPassInput')
    checkVerifyPassword(e) {
        var $newPass = $("#passInput");
        var $verifyNewPass = $("#verifyPassInput");

        var newPassword = $newPass.val();
        var verifyNewPassword = $verifyNewPass.val();

        if(newPassword.trim().length == 0 || verifyNewPassword.trim().length == 0) {
            $("#message").text(i18n.t("profile.noemptynewpass"));
            $("#message").addClass("fg-darkRed");

            $('#submit-btn').attr('disabled', true);

            return false;
        }

        if(newPassword != verifyNewPassword) {
            $("#message").text(i18n.t("register.nomatchpass"));
            $("#message").addClass("fg-darkRed");

            if($verifyNewPass.hasClass('notsame-input'))
                $verifyNewPass.removeClass('notsame-input');

            $verifyNewPass.removeClass('required-input')
                            .removeClass('invalid-input')
                            .removeClass('valid-input')
                            .addClass('notsame-input');

            $('#submit-btn').attr('disabled', true);

            return false;

        }else {

            if($verifyNewPass.hasClass('notsame-input'))
                $verifyNewPass.removeClass('notsame-input')
                                .addClass('valid-input');

            $("#message").empty();
            $("#message").removeClass("fg-darkRed");

            $('#submit-btn').removeAttr('disabled');

            return true;

        }
    }

    @on('keyup input#oldPassInput')
    oldPassCheck() {
        var $oldPassInput = $('#oldPassInput');
        var oldPassword = $oldPassInput.val();
        if (!oldPassword.length) {
            $oldPassInput.addClass('required-input');
        } else {
            $oldPassInput.removeClass('required-input');
        }
        $('#oldpsw-error-message').removeClass('confirm-failure').empty();
        $oldPassInput.removeClass('confirm-failure-input-borders');
    }

    @on('click #submit-btn')
    async submitNewPassword() {
        var url = '/CampaignCloud/PassReset/ChangePassword';
        var self = this;
        var $oldPassInput = $('#oldPassInput');

        var password = $oldPassInput.val();
        if (!password) {
            password = '';
        }
        var $passInput = $('#passInput');
        var $verifyPassInput = $('#verifyPassInput');

        // check if new passwords are empty
        if($passInput.val().trim().length == 0 || $verifyPassInput.val().trim().length == 0) {

            $.Notify.warn(i18n.t("profile.noemptynewpass"));
            return;

        } else // check if new passwords match
            if(!this.checkVerifyPassword()) {
                $.Notify.warn(i18n.t("register.nomatchpass"));
                return;
            }

        self.haveibeenpwned_pwd($passInput.val());
        var formValues = {
            email: this.model.get("email"),
            oldPassword: password,
            password: $passInput.val()
        };

        $oldPassInput.val('');
        $passInput.val('');
        $verifyPassInput.val('');

        try {
            const changePwdData = await $.ajaxDefaultQ({
                type: "POST",
                url: url,
                dataType: "json",
                data: formValues
            });

            if (changePwdData.status === 'success') {
                dhtmlx.alert(i18n.t("profile.passchangesuccess"));
                $('#newpass-form').hide();
                $('#thirdPartyAuthenticatedUserInfoMessage').hide();
                $('#oldPasswordDiv').show();
                $('#newpass-button').html(i18n.t("profile.changepass"));
                $('.progress-bar').removeClass('progress-bar-success');
                $('.password-verdict').html('');
                var $emailInput = $('#emailInput');
                $emailInput.addClass("edit");
                self.makeEditable(0, $emailInput, self);
            } else {
                if (changePwdData.responde === "PassNotEqual") {
                    dhtmlx.alert(i18n.t("profile.passchangesuccess"));
                } else if (changePwdData.response === "NotUserPass") {
                    $('#oldpsw-error-message').addClass('confirm-failure').empty().append(i18n.t("profile.wrongpass"));
                    $oldPassInput.addClass('confirm-failure-input-borders');
                } else {
                    dhtmlx.alert(i18n.t("register.internalerror"));
                }
            }

            $passInput.removeClass('valid-input');
            $passInput.addClass('required-input');

            $verifyPassInput.removeClass('valid-input');
            $verifyPassInput.addClass('required-input');

            $oldPassInput.addClass('required-input');

        } catch (e) {
            dhtmlx.alert(i18n.t("register.internalerror"));

            $passInput.removeClass('valid-input');
            $passInput.addClass('required-input');

            $verifyPassInput.removeClass('valid-input');
            $verifyPassInput.addClass('required-input');
            $oldPassInput.addClass('required-input');
        }

        $oldPassInput.attr("type", "password").trigger("keyup");
        $passInput.attr("type", "password").trigger("keyup");
        $verifyPassInput.attr("type", "password").trigger("keyup");
    }

    async haveibeenpwned_pwd(pwd) {
        const $haveibeenpwned = $('#haveibeenpwned-pwd-error-message');
        let s = sha1(pwd).toUpperCase();
        let prefix = s.substring(0, 5);
        let suffix = s.substring(5);
        const breachesopt = await $.ajaxDefaultQ({
            url: 'https://api.pwnedpasswords.com/range/' + prefix,
            type: 'GET',
            dataType: "text"
        });
        if (breachesopt.length) {
            let lines = breachesopt.split('\n');
            let found = lines.filter(e => e.startsWith(suffix));
            if (found.length) {
                let cnt = parseInt(found[0].split(':')[1]);
                console.log('Found:' + cnt);
                $haveibeenpwned
                    .show()
                    .html(i18n.t('register.haveibeenpwned-pwd-warning', {count: cnt}));
            } else {
                $haveibeenpwned.hide().html('');
            }
        } else {
            $haveibeenpwned.hide().html('');
        }
    }

    @on('click #show-user-actions')
    showUserActions() {
        if (!appUserActionIsVisible) {
            if (appUserActionView) {
                $('#display-app-user-action').show();
            } else {
                appUserActionView = new AppUserActionView();
            }
            appUserActionIsVisible = true;
        } else {
            $('#display-app-user-action').hide();
            appUserActionIsVisible = false;
        }
    }

    async checkUserName(input) {
        var username = $(input).val();
        var $username = $('#username-error-message');
        $username.empty();
        var re = new RegExp(/^([A-Za-z0-9.]{6,30})$/);
        if (re.test(username)) {
            try {
                const exist = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/UserInfo/existence/username?value=${encodeURIComponent(username)}`,
                    type: 'GET',
                    dataType: "json"
                });
                if (exist) {
                    $('#username-error-message').addClass('confirm-failure').empty().append(i18n.t("register.usernameexists"));
                    $(input).removeClass("valid").addClass("invalid");
                } else {
                    $(input).removeClass("invalid").addClass("valid");
                }
            } catch (e) {
                $('#username-error-message').addClass('confirm-failure').empty().append(i18n.t("register.servererror"));
                $(input).removeClass("valid").addClass("invalid");
            }
        } else {
            if (!(username.length >= 6 && username.length <= 30)) {
                $username.addClass('confirm-failure').empty().append(i18n.t("register.numberofcharacters"));
                $(input).removeClass("valid").addClass("invalid");
            } else {
                $username.addClass('confirm-failure').empty().append(i18n.t("register.allowedcharacters"));
                $(input).removeClass("valid").addClass("invalid");
            }
        }
    }

    usernameInput(input) {
        this.checkUserName(input);
    }

    usernameBlur() {
        $('#username-error-message').empty();
    }

    usernameSubmit(input) {
        if (!$(input).hasClass('valid')) {
            return false;
        }
    }

    numberIsValid(e, input, c) {
        var spriteel = $('#countryFlag');
        spriteel.removeClass();
        spriteel.addClass("flag-icon");
        $('.icon-warning').remove();
        var $msisdn = $('#msisdn-error-message');
        $msisdn.empty();
        $msisdn.hide();
        if (c) {
            spriteel.addClass("flag-icon-" + c.toLowerCase());
            $('#country-code').text(' ' + c + ' ');
        }
        $(input).removeClass("invalid").addClass("valid");
        this.$el.find("button[type=submit]").removeAttr("disabled");
    }

    numberIsInvalid(e, input) {
        var spriteel = $('#countryFlag');
        spriteel.removeClass();
        spriteel.html('<i id="countryFlag" class="icon-warning fg-darkRed"></i>');
        $('#country-code').text('');
        var $msisdn = $('#msisdn-error-message');
        $msisdn.show();
        $msisdn.text(i18n.t("profile.invalidcontactphone"));
        $(input).removeClass("valid").addClass("invalid");
        this.$el.find("button[type=submit]").attr("disabled", "disabled");
    }

    numberBlur(e, c, input) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
        if ($(e).hasClass('msisdn')) {
            var spriteel = $('#countryFlag');
            spriteel.removeClass();
            spriteel.addClass("flag-icon");
            var $country = $('#country-code');
            $country.text('');
            $('.icon-warning').remove();
            if (c) {
                spriteel.addClass("flag-icon-" + c.toLowerCase());
                $country.text(' ' + c + ' ');
            } else {
                $(input).parent().parent().parent().find("#countryFlag").removeClass();
            }

            $(input).removeClass("invalid").addClass("valid");
        }
        var val = input[0].value;
        if (!val || !$(input).hasClass("valid")) {
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            $(input).parent().parent().parent().find('#country-code').text('');
        }
    }

    numberSubmit(input) {
        var val = input[0].value;
        if (!val) {
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            $(input).parent().parent().parent().find('#country-code').text('');
            return true;
        }
        if (!input.hasClass('valid')) {
            $(input).parent().parent().parent().find('#country-code').text('');
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            return false;
        }
    }

    inputIsValid(e, input) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
        $(input).removeClass("invalid").addClass("valid");
    }

    inputIsInvalid(e, input, maxLength) {
        var message = $(e).next("span");
        message.text(i18n.t("profile.invalidlengthinput", {countLength: maxLength}));
        message.show();
        $(input).removeClass("valid").addClass("invalid");
    }

    inputSubmit(input) {
        if (input.hasClass('valid')) {
        } else {
            return false;
        }
    }

    inputBlur(e, c) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
    }

    emailIsValid(e, input) {
        var email = input[0].value;
        if (email || (this.model.get("msisdn") && this.model.get("msisdn"))) {
            var message = $(e).next("span");
            message.empty();
            message.hide();
            $(input).removeClass("invalid").addClass("valid");
            $(e).find("button[type=submit]").removeAttr("disabled");
        } else {
            this.emailIsInvalid(e, input);
        }
    }

    emailIsInvalid(e, input) {
        var email = input[0].value;
        if (!email && this.model.get("msisdn")) {
            this.emailIsValid(e, input);
        } else {
            var message = $(e).next("span");
            message.text(i18n.t("passwordrecover.notvalidmail"));
            message.show();
            $(input).removeClass("valid").addClass("invalid");
            $(e).find("button[type=submit]").attr("disabled", "disabled");
        }
    }

    emailSubmit(input) {
        if (input.hasClass('valid')) {
            $("#emailChangeAlert").hide();
        } else {
            return false;
        }
    }

    submitNewEmail(email) {
        var oldEmail = this.model.get('email');
        var newEmail = email;

        if (!((oldEmail.trim()) === (newEmail.trim()))) {
            var lng = i18n.language;
            var formValues = {
                oldEmail: oldEmail,
                newEmail: newEmail,
                lng: lng
            };

            $.ajaxDefaultQ({
                url: '/CampaignCloud/EmailChangeRequest',
                type: 'POST',
                dataType: "json",
                data: formValues
            }).done(function (data) {
                if (data.status === 'success') {
                    dhtmlx.alert(i18n.t("profile.emailchangerequestsuccess"));
                    $('#email-for-confirmation').text(newEmail);
                    $('#pending-change-email-confirmation').show();
                } else {
                    dhtmlx.alert(i18n.t("register.internalerror"));
                }

            }).fail(function () {
                dhtmlx.alert(i18n.t("register.internalerror"));
            });
        }
    }

    @on('click #reject-change')
    async rejectChangeEmail() {
        var url = '/CampaignCloud/EmailChangeRequest/RejectEmailChangeRequest';
        try {
            const data = await $.ajaxDefaultQ({
                type: "POST",
                url: url,
                dataType: "json",
            });
            if (data.status === 'success') {
                $('#pending-change-email-confirmation').hide();
                $('#emailInput').editable('enable');
            } else {
                throw new Error(data);
            }

        } catch (e) {
            dhtmlx.alert(i18n.t("register.internalerror"));
        }
    }

    async showPrompts() {
        try {
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/ShowPrompts/profile',
                type: 'get',
                dataType: 'json'
            });
            if (response) {
                if (response[0] === true) {
                    $('#learnMore').html(`${i18n.t("profile.learnMore")} <i class="icon-help padding5"></i>`);
                    $('#invoiceInfo').show();
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    async promptClosedByUser(event) {
        var data = $(event.currentTarget).parent().parent().data();
        var id = data['id'];
        if (id !== undefined && id === 4) {
            try {
                const response = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/ShowPrompts/' + id,
                    type: 'post',
                    dataType: 'json'
                });
                if (response) {
                    if (response.toClose === true) {
                        $('[data-id=' + response.id + ']').hide();
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }
    }
}

export default ProfileUserView;
